import { main } from "./movie/main.es6";

document.addEventListener("DOMContentLoaded", main);
